import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ManagerApi from "../../api/manager.api";
import EditBtn from "../../component/atoms/button/editBtn";
import DetailPage from "../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../component/atoms/layout/mainLayout";
import DetailFormText from "../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../component/molecules/goBack";
import Header from "../../component/organisms/header";
import Sidebar from "../../component/organisms/sidebar";
import { route } from "../../router/route";
import { errorHandler } from "../../util/errorHandler";

function ManagerDetail(props) {
  // import
  const navigate = useNavigate();
  let { id } = useParams();

  // mounted
  useEffect(() => {
    getManagerInfo();
  }, []);

  // ----- 정보 가져오기
  const [managerInfo, setManagerInfo] = useState({
    name: "",
    email: "",
    rootFlag: "",
  });

  const getManagerInfo = async () => {
    try {
      const response = await ManagerApi.getById(id);
      setManagerInfo({
        ...response.data.data.content,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {sessionStorage.getItem("role") === "ROOT" ||
            Number(sessionStorage.getItem("id")) === Number(id) ? (
              <EditBtn
                onClick={() => {
                  if (sessionStorage.getItem("role") === "ROOT") {
                    navigate(route.manager_edit_root + `/${id}`);
                  } else {
                    navigate(route.manager_edit_admin + `/${id}`);
                  }
                }}
              />
            ) : null}
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{managerInfo.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <DetailFormText>{managerInfo.email}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>관리자 유형</DetailFormTitle>
                <DetailFormText>
                  {managerInfo.rootFlag ? "ROOT" : "ADMIN"}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>등록일</DetailFormTitle>
                <DetailFormText>
                  {moment.utc(managerInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
}

export default ManagerDetail;
